import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import './ParkingDayConfig.scss';
import { BuildingParkingDayConfig, Loading } from '../../components';
import { 
  fetchGetParkingDayConfig, 
  setBuildingParkingDayConfig,
  fetchUpdateParkingDayConfig,
} from '../../actions';
import commonConstant from '../../common/_commonConstant';

class ParkingDayConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'loading': false,    
    };
  }
  componentDidMount() {
    this.setState({
      'loading': true,
    });
    this.props.dispatch(fetchGetParkingDayConfig(this.props.match.params.buildingID, 'WEEKDAY,WEEKEND'));
  }

  componentDidUpdate(prevProps) {
    const { getParkingDayConfig, updateParkingDayConfig } = this.props;

    if (getParkingDayConfig.status === 200 && getParkingDayConfig.type === commonConstant.GET_PARKING_DAY_CONFIG_SUCCESS && prevProps.getParkingDayConfig != getParkingDayConfig) {
      const parkingDayConfigData = [];

      for (let i = 0; i < getParkingDayConfig.data.parkingDayConfig.length; i++) {
        const data = getParkingDayConfig.data.parkingDayConfig[i];
        parkingDayConfigData.push(
          {
            'parkingDayConfigDayType': data.dayType,
            'parkingDayConfigParkingZone': data.parkingZone,
            'parkingDayConfigAllowance': data.allowance,
            'parkingDayConfigChargeCustomer': data.chargeCustomer,
            'parkingDayConfigStartDatetime': data.startDatetime,
            'parkingDayConfigEndDatetime': data.endDatetime,
            'parkingDayConfigID': data.parkingDayConfigID,
          },
        );
      }

      this.props.dispatch(setBuildingParkingDayConfig({
        'parkingDayConfig' : parkingDayConfigData,
        'isCanSave' : true,
      },
       
      ));

      this.setState({
        'loading': false,
      });
    } else if (updateParkingDayConfig.status === 200 && updateParkingDayConfig.type === commonConstant.UPDATE_PARKING_DAY_CONFIG_SUCCESS && prevProps.updateParkingDayConfig != updateParkingDayConfig) {
      this.props.dispatch(fetchGetParkingDayConfig(this.props.match.params.buildingID, 'WEEKDAY,WEEKEND'));
    }
  }

  handelCancel = () => {
    this.setState({
      'loading': true,
    });
    this.props.dispatch(fetchGetParkingDayConfig(this.props.match.params.buildingID, 'WEEKDAY,WEEKEND'));
  }

  handleDataForDispatch = () => {
    const { buildingParkingDayConfig } = this.props;

    return buildingParkingDayConfig.data.parkingDayConfig.map((data) => (
      {
        'allowance': data.parkingDayConfigAllowance,
        'buildingID': this.props.match.params.buildingID,
        'chargeCustomer': data.parkingDayConfigChargeCustomer,
        'dayType': data.parkingDayConfigDayType,
        'endDatetime': data.parkingDayConfigEndDatetime,
        'parkingDayConfigID': data.parkingDayConfigID,
        'parkingZone': data.parkingDayConfigParkingZone,
        'startDatetime': data.parkingDayConfigStartDatetime,
      }
    ));
  }

  handleUpdateParkingDayConfig = () => {
    this.setState({
      'loading': true,
    });    

    this.props.dispatch(fetchUpdateParkingDayConfig({
      'data' : this.handleDataForDispatch(),
    }));
  }


  render() {
    const { loading } = this.state;

    if (loading) {
      return <Loading/>;
    }

    return (
      <div className="ParkingDayConfig layout-box-page-without-margin">
        <div className="parking-day-config-header">
          <div className="parking-day-config-title">Parking day config</div>
          <div className="parking-day-config-button-container">
            <div className="draft-button-container">
              <Button onClick={() => this.handelCancel()} className="btn-sixtary draft-button" >ยกเลิก</Button>
            </div>
            <Button onClick={() => this.handleUpdateParkingDayConfig()} className="btn-primary send-data-button">อัปเดต</Button>
          </div>
        </div>
        <div className="parking-day-config-container">
          <BuildingParkingDayConfig pathMatch={this.props.match}/>
        </div> 
      </div>
    );
  }
}

const mapStateToProps = ({ 
  getParkingDayConfig, 
  buildingParkingDayConfig, 
  updateParkingDayConfig,
}) => 
  ({ 
    getParkingDayConfig, 
    buildingParkingDayConfig,
    updateParkingDayConfig, 
  });

export default connect(mapStateToProps)(ParkingDayConfig);

ParkingDayConfig.propTypes = {
  'dispatch' : PropTypes.func,
  'match' : PropTypes.shape({
    'params' : PropTypes.shape({
      'buildingID' : PropTypes.string,
    }),
  }),
  'getParkingDayConfig' : PropTypes.shape({
    'status' : PropTypes.number,
    'type' : PropTypes.string,
    'data' : PropTypes.shape({
      'parkingDayConfig' : PropTypes.arrayOf({
        'dayType' : PropTypes.string,
        'parkingZone' : PropTypes.string,
        'allowance' : PropTypes.string,
        'chargeCustomer' : PropTypes.string,
        'startDatetime' : PropTypes.string,
        'endDatetime' : PropTypes.string,
        'parkingDayConfigID' : PropTypes.string,
      }),
    }),
  }),
  'buildingParkingDayConfig' : PropTypes.shape({
    'data' : PropTypes.shape({
      'parkingDayConfig' :PropTypes.arrayOf(
        PropTypes.shape({          
          'parkingDayConfigDayType': PropTypes.string,        
          'parkingDayConfigParkingZone': PropTypes.string,
          'parkingDayConfigAllowance': PropTypes.string,
          'parkingDayConfigChargeCustomer': PropTypes.string,
          'parkingDayConfigStartDatetime': PropTypes.string,
          'parkingDayConfigEndDatetime': PropTypes.string,
        }),
      ),
    }),
  }),
  'updateParkingDayConfig' : PropTypes.shape({
    'status' : PropTypes.number,
    'type' : PropTypes.string,
  }),
};
